<div *ngIf="userService.user$ | async as cUser" class="flex flex-col w-full">
    <div class="country-select-wrap">
        <div *ngIf="countryRequiredErrorVisible()"
             class="country-select-error mat-mdc-form-field-error"
             role="alert">
            {{'Vous devez choisir un pays'|transloco}}
        </div>
        <mat-form-field appearance="fill" class="w-full country-select-field">
            <mat-select [formControl]="fGroup.get('internal_country')">
                <mat-option *ngFor="let country of countries"
                            [value]="country.abbreviation">
                    <div class="w-full flex flex-row">
                        <div>
                            <img class="h-10"
                                 [src]="'assets/images/flags/' + country.abbreviation?.toUpperCase() + '.svg'"
                                 [alt]="'Flag image for ' + country.country"
                            >
                        </div>
                        <div class="ml-1">{{country.country | translateLabel:curLang}}</div>
                    </div>

                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div *ngIf="fGroup.get('internal_country').value" class="flex flex-col" style="max-height: 320px;overflow-y: auto;">
        <button *ngFor="let aState of states[fGroup.get('internal_country').value]"
                mat-raised-button
                class="mb-2 w-full whitespace-pre-wrap ext-profile-choice-btn"
                [ngClass]="{'text-white	bg-green-inbe': cUser?.extProfiles?.['etat_province_usa_canada']===fGroup.get('internal_country').value + '-' + aState.abbreviation }"
                (click)="chooseState(fGroup.get('internal_country').value, aState.abbreviation)"
        >
            ({{aState.abbreviation}}) - {{aState.name | translateLabel:curLang}}
        </button>
    </div>
</div>
